import React, { useState, useEffect, Fragment } from "react";
import { Box, Grid } from "@mui/material";
import Header from "../components/Header";
import PIDImageContainer from "../components/PIDImageContainer/PIDImageContainer";
import ChatPanel from "./ChatPanel/ChatPanel";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getFile } from "../../../core/repo/fileRepo";
import Loader from "../../../components/Loader";
import PIDTabs from "../components/PIDTabs";

function PIDSessionView() {
  const [pidFile, setPidFile] = useState(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const pidFileId = queryParams.get("fileId");
  const tabId = queryParams.get("tabId");
  const [toggleChatPanelView, setToggleChatPanelView] = useState(true);
  const [isolationMarkup, setIsolationMarkup] = useState(null);
  const [selectedIsolationMarkup, setSelectedIsolationMarkup] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const handleToggleChatPanelView = () => {
    setToggleChatPanelView((prev) => !prev);
  };

  const handleIsolationMarkupChange = (isolationMarkup) => {
    setIsolationMarkup(isolationMarkup);
  };

  const handleSelectedIsolationMarkupChange = (isolationMarkup) => {
    setSelectedIsolationMarkup(isolationMarkup);
  };

  async function fetchPidFile() {
    try {
      const response = await dispatch(getFile(pidFileId));
      setPidFile(response);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (pidFileId) {
      fetchPidFile();
    }
  }, [pidFileId]);

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      height={"100%"}
      position={"relative"}>
      <PIDTabs />
      {isLoading && <Loader />}
      {!isLoading && pidFileId && pidFile && (
        <Fragment>
          <Header
            pidFile={pidFile}
            toggleChatPanelView={toggleChatPanelView}
            handleToggleChatPanelView={handleToggleChatPanelView}
          />
          <Box flex={1} overflow={"auto"} position={"relative"}>
            <Grid container height={"100%"}>
              <Grid
                item
                size={{
                  md: toggleChatPanelView ? 8 : 12,
                }}
                sx={{
                  backgroundColor: (theme) => theme.palette.background.light,
                }}
                height={"100%"}
                width={"100%"}
                position={"relative"}>
                <PIDImageContainer
                  pidFile={pidFile}
                  isolationMarkup={isolationMarkup}
                  selectedIsolationMarkup={selectedIsolationMarkup}
                  onIsolationMarkupChange={handleIsolationMarkupChange}
                />
              </Grid>
              {toggleChatPanelView && (
                <Grid
                  item
                  size={{ md: 4 }}
                  height={"100%"}
                  sx={{
                    borderLeft: (theme) => `1px solid ${theme.palette.divider}`,
                    display: "flex",
                    flexDirection: "column",
                  }}>
                  <ChatPanel
                    onIsolationMarkupChange={handleIsolationMarkupChange}
                    onSelectedIsolationMarkupChange={
                      handleSelectedIsolationMarkupChange
                    }
                  />
                </Grid>
              )}
            </Grid>
          </Box>
        </Fragment>
      )}
    </Box>
  );
}

export default PIDSessionView;
